import React, { createContext, useState, useContext } from 'react';

// Create the context
const AnalysisContext = createContext();

// Create a provider component
export const AnalysisProvider = ({ children }) => {
    const [analysis, setAnalysis] = useState(null);

    return (
        <AnalysisContext.Provider value={{ analysis, setAnalysis }}>
            {children}
        </AnalysisContext.Provider>
    );
};

// Custom hook to use the analysis context
export const useAnalysis = () => useContext(AnalysisContext);